import {useEffect, useState} from "react";

export default function useFetchJobData(intl, getEditPopupJobResponse) {
  const [loading, setLoading] = useState(false);

  const fetchJobIdData = async () => {
    setLoading(true);
    await getEditPopupJobResponse(intl);
    setLoading(false);
  }

  useEffect(() => {
    fetchJobIdData();
  }, []);

  return loading
}
